import { useEffect, useState} from 'react';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { navigationPropertiesTypes, useNavigation } from "./routes/Navigation";
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import AuthLayout from './layout/auth/AuthLayout';
import DashboardLayout from './layout/Dashboard/DashboardLayout';
import { pageData } from './metadescriptions';
import MeetLayout from './layout/Meet/MeetLayout';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, lightTheme } from 'amazon-chime-sdk-component-library-react';
import { initDatabase } from './database';
import { isPlatform } from '@ionic/react';
import { getAppVersion } from './utils/helper';
import { useQuery } from '@apollo/client';
import { GET_VERSION } from './pages/Help/api/Help';
import ConfirmationPopup from './components/ConfirmationPopup/ConfirmationPopup';
import images from './assets/images';
import { useDispatch } from 'react-redux';
import { useAppSelector } from './redux/app/hooks';
import { setLoginUser } from './redux/slices/authSlice';

function App() {
  
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isForceUpdate, setIsForceUpdate] = useState(false);
  const [updateUrl, setUpdateUrl] = useState('');
  const location = useLocation();
  const pathname = location.pathname;
  const {navigation} = useNavigation();
  const { logoutGif } = images;
  // Get the Token from the Redux
  const accessToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || '';
  const dispatch = useDispatch();
  const isKaton = useAppSelector((state) => state.auth.isKaton);

  const { data: version } = useQuery(GET_VERSION, {
    variables: { platformtype: isPlatform('android') ? 'ANDROID' : 'EXE'},
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    document.addEventListener('deviceready', onDeviceReady, false);
    return () => {
      document.removeEventListener('deviceready', onDeviceReady, false);
    };
  }, [version]);

  const compareVersions = (v1: string|null, v2: string) => {
    const v1Parts = v1 ? v1?.split('.').map(Number) : [];
    const v2Parts = v2?.split('.').map(Number);
    const length = Math.max(v1Parts.length, v2Parts.length);
    for (let i = 0; i < length; i++) {
      const a = v1Parts[i] || 0;
      const b = v2Parts[i] || 0;
      if (a > b) return 1;
      if (a < b) return -1;
    }
    return 0;
  };

  const onDeviceReady = async () => {
    try {
      const currentVersion = await getAppVersion();

      const latestVersion = version?.allVersions?.nodes[0]?.appVersion;
      const isForceUpdateFlag = version?.allVersions?.nodes[0]?.isForceUpdate;
      const playStoreUrl = 'https://install.appcenter.ms/orgs/360classroom-android-native/apps/360classroom/releases/9?source=email#x3D;email&tid=dDzfCsdcgKk';

      console.log(currentVersion,'======currentVersion');
      
      console.log(latestVersion,isForceUpdateFlag,'======latest version');
      

      if (compareVersions(currentVersion, latestVersion) < 0) {
        console.log('the app is in force update');
        setIsForceUpdate(isForceUpdateFlag);
        setUpdateUrl(playStoreUrl);
        setShowUpdateModal(true);
      }
    } catch (error) {
      console.error('Version check failed:', error);
    }
  };

  useEffect(() => {
    const pageInfo = pageData[pathname];
    if (pageInfo) {
        document.title = `Katon360 Classroom - ${pageInfo.title}`;

        const metaDescriptionTag = document.querySelector('head > meta[name="description"]');
        if (metaDescriptionTag) {
            metaDescriptionTag.setAttribute("content", pageInfo.metaDescription);
        }
    }
}, [pathname]);

  useEffect(() => {

    const params = new URLSearchParams(location?.search);
    const loginAs: any = params.get('loginAs');
    console.log("[Log]", { document, isKaton, params, loginAs });
    if (loginAs) {
      dispatch(setLoginUser({ loginAs }));
    }
    if(isPlatform('android')){
      initDatabase()
      .then(() => {
          console.log('Database initialized');
      })
      .catch((error) => {
          console.error('Database initialization failed', error);
      });
    }
  }, []);

  const handleUpdate = () => {
    if (window?.cordova && window?.cordova?.InAppBrowser) {
      window?.cordova?.InAppBrowser.open(updateUrl, '_system');
    } else {
      window.open(updateUrl, '_blank');
    }
  };

  const handleSkip = () => {
    setShowUpdateModal(false);
  };

  console.log(showUpdateModal,'====showUpdateModal')

  return (
    <>
      <Routes>
        <Route path="*" element={<Navigate to='/'/>}/>
        {/* Public Routes */}
        {
          navigation?.public?.map((route: navigationPropertiesTypes)=>(
            <Route 
              path={route.path}
              key={route.path}
              element={
                <PublicRoute>
                  <AuthLayout component={route.component}/>
                </PublicRoute>
              }
            />
          ))
        }
        {/* Private Routes access only after SignIn */}
        { accessToken &&
            navigation?.private?.map((route: navigationPropertiesTypes)=>(
            <Route
            path={route.path}
            key={route.path}
            element={
              <PrivateRoute>
                <DashboardLayout component={route.component}/>
              </PrivateRoute>
            }
            />
          ))
        }
        { accessToken &&
            navigation?.meet?.map((route: navigationPropertiesTypes)=>(
            <Route
            path={route.path}
            key={route.path}
            element={
              <PrivateRoute>
                <ThemeProvider theme={lightTheme}>
                <GlobalStyles />
                <MeetLayout component={route.component}/>
                </ThemeProvider>
              </PrivateRoute>
            }
            />
          ))
        }
      </Routes>
      {showUpdateModal && (
        <ConfirmationPopup
          open={showUpdateModal}
          page={`AppUpdate`}
          isForceUpdate={isForceUpdate}
          message={isForceUpdate ? 'A new version of the app is available. Please update to continue.' : 'A new version of the app is available. Would you like to update?'}
          gifData={logoutGif}
          yesButtonFunctionality={handleUpdate}
          noButtonFunctionality={!isForceUpdate ? handleSkip : () => {}}
          messageWidth={'300px'}
        />
      )}
    </>
  );
}

export default App;
